import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function ForWhoSection() {
  return <Section background="cream" data-id="element-1">
      <h2 className="text-3xl md:text-4xl font-bold text-[#2D2D2D] mb-12 text-center font-serif" data-id="element-2">
        ¿Es este programa para ti?
      </h2>

      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-3">
        {/* YES Column */}
        <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-[#1A5F5A]" data-id="element-4">
          <h3 className="text-xl font-bold text-[#1A5F5A] mb-6 flex items-center" data-id="element-5">
            <span className="bg-[#E8F2F1] p-2 rounded-full mr-3" data-id="element-6">
              <Check className="w-5 h-5" data-id="element-7" />
            </span>
            SÍ es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-8">
            {['Tienes 65 años o más', 'Sientes dolor leve a moderado o inestabilidad', 'Quieres caminar con menos miedo sin ir al gimnasio', 'Estás cansada de consejos sueltos que no funcionan', 'Buscas una solución suave pero efectiva'].map((item, i) => <li key={i} className="flex items-start text-[#4A4A4A]" data-id="element-9">
                <Check className="w-5 h-5 text-[#1A5F5A] mr-3 shrink-0 mt-0.5" data-id="element-10" />
                <span data-id="element-11">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* NO Column */}
        <div className="bg-[#F5F2EB] p-8 rounded-2xl border-t-4 border-[#C96B4B]" data-id="element-12">
          <h3 className="text-xl font-bold text-[#C96B4B] mb-6 flex items-center" data-id="element-13">
            <span className="bg-[#FDFBF7] p-2 rounded-full mr-3" data-id="element-14">
              <X className="w-5 h-5" data-id="element-15" />
            </span>
            NO es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-16">
            {['Tu dolor es agudo o insoportable', 'Tienes inflamación fuerte visible', 'Sufres bloqueo articular (la rodilla se traba)', 'Tuviste una caída reciente grave', 'Buscas entrenamientos de alta intensidad'].map((item, i) => <li key={i} className="flex items-start text-[#4A4A4A]" data-id="element-17">
                <X className="w-5 h-5 text-[#C96B4B] mr-3 shrink-0 mt-0.5" data-id="element-18" />
                <span data-id="element-19">{item}</span>
              </li>)}
          </ul>
          <p className="mt-6 text-sm text-[#4A4A4A] italic border-t border-gray-200 pt-4" data-id="element-20">
            *Si tienes alguno de estos síntomas, por favor consulta primero con
            tu médico.
          </p>
        </div>
      </div>
    </Section>;
}